import {Component, Watch} from "vue-property-decorator";
import {mapActions, mapGetters} from "vuex";
import {ActionTypes} from "@/vuex/modules/logs-module/action-types";
import {PageMixin} from "@/mixins/pageMixin";
import {LogsSearchParams} from "@/vuex/modules/logs-module/actions";
import Log from "@/vuex/models/log/log";
import Meta from "@/vuex/models/meta";
import {LogsSortableColumns} from "@/services/helpers/sort";
import {Debounce} from "vue-debounce-decorator";

@Component({
    methods: mapActions({
        fetchLogs: ActionTypes.FETCH_LOGS,
    }),
    computed: mapGetters({
        logs: 'logs',
        meta: 'logsMeta'
    })
})
export default class UserLogsView extends PageMixin {
    protected readonly fetchLogs!: (params: LogsSearchParams) => Promise<void>;

    protected readonly logs!: Log[];
    protected readonly meta!: Meta;
    protected readonly sortableColumns = LogsSortableColumns;

    protected searchParams: LogsSearchParams = {
        page: 1,
        per_page: 25,
        direction: null,
        column: null,
        search: null
    }

    protected async created(): Promise<void> {
        await this.paginate();
    }

    @Watch('searchParams', {deep: true})
    protected async paginate(): Promise<void> {
        this.loading = true;
        await this.fetchLogs(this.searchParams);
        this.loading = false;

        this.pagination = this.meta;
    }

    protected setPage(page: number): void {
        this.searchParams.page = page;
    }

    protected sortColumn(column: string): void {
        this.searchParams = this.sort(column, this.searchParams);
    }

    @Debounce(350)
    protected searchLogs(search: string): void {
        const params = this.search(search, this.searchParams);

        if (!!params) {
            this.searchParams = params;
        }
    }
}
